import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsOneStep.PersonsValidationError', {
    atLeastOne: 'At least one director should have verification details provided',
});
